export const AUTH_ROUTES = {
  REGISTER: '/auth/register',
  VERIFY: '/auth/verify',
  RESEND_CODE: '/auth/resend-code',
  LOGIN: '/auth/login',
  REFRESH: '/auth/refresh',
  LOGOUT: '/auth/logout',
  ME: '/auth/me',
} as const;
